import { ThumbaIcon } from "@roman/shared/components/Icons";
import { Link } from "react-router-dom";

export const NoRoundData = () => {
  return (
    <div className="min-h-screen bg-blue w-full">
      <div className="flex flex-col justify-center items-center">
        <div className="pt-12 text-primary">
          <ThumbaIcon className="w-[138px] h-[78px] opacity-10" />
        </div>
        <div className="flex justify-center items-center text-[14px] text-primary pt-8 pb-4 px-4">
          あなたがエントリーした大会で
          <br />
          現在開催中の大会はありません。
        </div>
        <Link to="/" className="flex justify-center items-center">
          <button
            type="button"
            className="px-8 sm:px-16 py-2 border border-primary text-primary font-bold text-[16px] bg-white rounded-lg whitespace-nowrap min-w-[160px] sm:min-w-[200px]"
          >
            追加エントリーして賞金を獲得する
          </button>
        </Link>
      </div>
    </div>
  );
};
